<!--
  @Description 开发进度柱状图
  @Date 2022-01-09
  @Author liushuo
-->
<template>
  <div id="lineChart" :style="{ width: '600px', height: '300px' }"></div>
</template>

<script>
export default {
  name: 'lineChart',
  props: {

  },
  data () {
    return {
      barWidth: 20,
      // 姓名
      nameData: [],
      // 已完成
      valueData: [],
      // 任务总量
      backData: []
    }
  },

  watch: {
    nameData: {
      handler () {
        this.drawLine()
      },
      deep: true
    }
  },
  mounted () {
    this.drawLine();
  },
  methods: {
    drawLine () {
      // 基于准备好的dom，初始化echarts实例
      let myChart = this.$echarts.init(document.getElementById('lineChart'))

      let option = {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            crossStyle: {
              color: '#999'
            }
          },
        },
        xAxis: {
          // data: ['鄢国平', '刘铄', '刘福', '郑济昌', '林源晟', '张镇波', '陈天生', '陈晓萍', '陈小燕', '蔡志扬', '曾佳炜', '柯仁杰', '张光胜', '李康',],
          data: this.nameData,
          // 是否显示坐标刻度
          axisTick: { show: false },
          offset: 10,
          axisLabel: { interval: 0, rotate: 30 },
          // axisLabel: {
          //   formatter: "barGap: '-100%'"
          // }
        },
        title: {
          text: '任务完成情况',
          left: 'center'
        },
        // 调整图表内边距
        grid: {
          x: 30,
          y: 60,
          x2: 20,
          y2: 50,
        },
        yAxis: {
          // splitLine: { show: false }
        },
        series: [
          // 总任务数
          {
            name: '总任务数',
            type: 'bar',
            itemStyle: {
              normal: {
                color: '#eeeeee'
              }
            },
            silent: true,
            barWidth: this.barWidth,
            // barGap="-100%" 设置两个bar重叠
            barGap: '-100%',
            // data: [60, 60, 60, 60, 60, 60, 60, 60, 60, 60, 60, 60, 60, 60]
            data: this.backData
          },

          // 已完成数
          {
            name: '已完成数',
            type: 'bar',
            barWidth: this.barWidth,
            // itemStyle: {
            //   normal: {
            //     color: '#4584e6'
            //   }
            // },
            itemStyle: {
              normal: {
                color: '#4584e6'
              },
              color: {
                type: 'linear',
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                // 渐变色会导致 colorStops: [{
                //   offset: 0, color: '#eee' // 0% 处的颜色
                // }, {
                //   offset: 1, color: '#4584e6' // 100% 处的颜色
                // }],
                global: false // 缺省为 false
              }
            },
            label: {
              show: true,
              position: 'top',
              color: '#1030C6'
            },
            z: 10,
            // data: [45, 60, 13, 25, 45, 60, 13, 25, 45, 60, 13, 25, 45, 60]
            data: this.valueData
          }
        ]
      };
      // 绘制图表
      myChart.setOption(option);
    }
  }
}
</script>

<style lang="less" scoped>
</style>
